String.prototype.replaceArray = function(find, replace) {
    var replaceString = this;
    var regex; 
    for (var i = 0; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        replaceString = replaceString.replace(regex, replace[i]);
    }
    return replaceString;
};


function checkCurrentUser(){

    //CHECK IF CURENT PATHNAME IS EXCLUDED
    let pathname = window.location.pathname;
    let excluded_pathnames = [
        '/worktime-addition',
        '/admin/worktime_addition',
        '/traffic',
        '/day-off-request'
    ];
    let current_pathname_is_excluded= excluded_pathnames.includes(pathname);

    //IF THE CURRENT PATH IS NOT EXCLUDED -> CHECK THE USER
    if(!current_pathname_is_excluded){
        let last_business_day_ok = true;
        let unscheduled_tasks_ok = true;
        let messages = [];
        let buttons = [];

        //CHECK FOR LAST BUSINESS DAY
        axios.get(baseURL+'/api/user/timesheet_check')
            .then(function(response){
                console.log('response:');
                console.log(response);

                switch(response.data.response_shortcode) {
                    case 'not_enough_time_record':

                        let failed_day_string="<ul>";
                        console.log(response.data.failed_days);

                        $.each(response.data.failed_days,function(index,day){
                            console.log(day.date);
                            failed_day_string+='<li>';
                            failed_day_string+=day.date;
                            failed_day_string+='</li>';
                        });

                        failed_day_string+='</ul>';

                        console.log(failed_day_string);

                        last_business_day_ok = false;
                        messages.push('A jelenlegi hónapban vannak hiányosan kitöltött napok, ahol nincs meg a kötelező időmennyiség <a class="tippy-button" data-tippy-content="<b>Megoldás:</b> Vidd fel a munkaóráidat vagy a még nem felvitt szabadságod az adott napokra. ">[?]</a> <br> '+ failed_day_string );

                        if(unscheduled_tasks_ok == true){
                            buttons.push(
                                $.extend({}, vex.dialog.buttons.NO, { className: 'check_dialog_button_traffic', text: 'Traffic', click: function(e) {
                                        this.value = 'traffic';
                                        location.href=baseURL+'/traffic';
                                        this.close();
                                    }}));
                        }

                        buttons.push(
                            $.extend({}, vex.dialog.buttons.NO, { className: 'check_dialog_button_worktime_addition', text: 'Munkaóra rögzítés', click: function(e) {
                                    this.value = 'worktime_addition';
                                    location.href=baseURL+'/admin/worktime_addition';
                                    this.close();
                                }}));

                        buttons.push(
                            $.extend({}, vex.dialog.buttons.NO, { className: 'check_dialog_button_day_off_request', text: 'Szabadság igénylés', click: function(e) {
                                    this.value = 'day_off_request';
                                    location.href=baseURL+'/day-off-request';
                                    this.close();
                                }}));
                        break;

                }

                //CHECK FOR UNSCHEDULED TASKS
                /*
                axios.get(baseURL+'/api/check/unscheduled_tasks')
                    .then(function(response){
                        switch(response.data.status){
                            case 'not_ok':
                                unscheduled_tasks_ok = false;
                                messages.push('Vannak egy munkanapnál régebbi, nem behúzott feladataid. <a class="tippy-button" data-tippy-content="<b>Megoldás:</b> Helyezd el a feladataid a traffic naptárban.">[?]</a>');
                                buttons.push(
                                    $.extend({}, vex.dialog.buttons.NO, { className: 'check_dialog_button_traffic', text: 'Traffic', click: function(e) {
                                            this.value = 'traffic';
                                            location.href=baseURL+'/traffic';
                                            this.close();
                                        }}));
                                break;
                        }
                    })
                    .catch(function(error){

                    });
                */

                //FIRE THE DIALOG IF NEEDED + POST THE CURRENT URL TO THE SERVER
                if(last_business_day_ok == false /*|| unscheduled_tasks_ok == false*/){

                    axios.post(baseURL+'/api/user/last_url',{
                        "url":window.location.href
                    }).then(function(){

                        let title = "Kérjük, rendezd a következő tételeket:";

                        //CONSTRUCT MESSAGES
                        let dialog_message = "";
                        dialog_message+="<ul>";
                        $.each(messages,function(message_index,message){
                            dialog_message+="<li>";
                            dialog_message+=message;
                            dialog_message+="</li>";
                        });
                        dialog_message+="</ul>";

                        console.log(dialog_message);

                        vex.dialog.open({
                            message:title,
                            input: dialog_message,
                            overlayClosesOnClick: false, // set false to click out
                            escapeButtonCloses:false,
                            callback: function (value) {
                                console.log(value);
                            },
                            afterOpen:function(){
                                tippy('.tippy-button', {
                                    interactive: true,
                                    size:'large',
                                    theme:'odin'
                                });
                            },
                            buttons: buttons
                        });
                    });

                }

            })
            .catch(function(error){
                console.log('error:');
                console.log(error);
            });
    }

}


var vm=new Vue({
    el:'body',
    data: {
        viewport_height: $(window).height(),
        scroll_indicator: false
    },
    created: function() {
        vueInstance = this;
        $(document).click(function (e) {
            e.stopPropagation();
            var container = $(".admin_panel, .admin_panel_icon");

            if (container.has(e.target).length === 0) {
                $(".admin_panel").removeClass("visible");
            }
        });
        vex.defaultOptions.className="vex-theme-flat-attack";
        window.addEventListener('scroll', this.bodyScroll);

    },
    destroyed: function() {
        window.removeEventListener('scroll', this.bodyScroll);
    },
    methods: {

    checkUserUnscheduledTasks:function(){
        axios.get(baseURL+'/api/check/unscheduled_tasks')
            .then(function(response){
                switch(response.data.status){
                    case 'not_ok':
                        console.log('redirecting user to traffic page with the tasks');

                        if(window.location!=response.data.redirect_url){

                            vex.dialog.open({
                                message: 'Kérjük, a még nem beosztott feladataidat helyezd el a traffic táblád naptárába.',
                                overlayClosesOnClick: false, // set false to click out
                                callback (value) {
                                    console.log(value);
                                    location.href = response.data.redirect_url;
                                },
                                buttons: [
                                    $.extend({}, vex.dialog.buttons.YES, { text: 'OK' }),
                                ]
                            });


                        }
                        break;
                }
            })
            .catch(function(error){

            });
        },

        //GET IF THE  CURRENT USER'S TIMESHEET IS OKAY, IF NOT DISPLAY A NOTIFICATION AND REDIRECT IT TO THE TIMESHEET LOADING PAGE
        checkUserTimeSheet:function(){

            if(window.location.pathname != '/admin/workime_addition' && window.location.pathname != '/traffic') {

                axios.get(baseURL+'/api/user/timesheet_check')
                    .then(function(response){
                        console.log('response:');
                        console.log(response);

                        switch(response.data.response_shortcode) {
                            case 'not_enough_time_record':
                                vueInstance.showTimeSheetErrorAlert();
                                break;
                            case 'user_is_ok':
                                vueInstance.checkUserExpiredProjects();
                                break;
                        }
                    })
                    .catch(function(error){
                        console.log('error:');
                        console.log(error);
                    });
            }
        },
        checkUserExpiredProjects:function(){
            if (!alert_expired_projects) {
                return;
            }
            axios.get(baseURL+'/api/project/expired')
                .then(function(response){

                    if (response.data.status == "ok") {
                        return;
                    }

                    var url;

                    if (response.data.status == "ticket_found") {
                        url = vueInstance.generateTicketUrl(response.data.data, response.data.data.ticket, true);

                        if (window.location.href != url && window.location.href != baseURL+"/admin/project/"+response.data.data.id+"/edit/ticket/"+response.data.data.ticket.id || window.location.href!=baseURL+'/traffic') {
                            vueInstance.showExpiredProjectErrorAlert(url, 'Egy vagy több ticketed határideje lejárt. Zárd le vagy módosítsd a határidejét.');
                        }
                    } else if (response.data.status == "project_found") {
                        url = vueInstance.generateProjectUrl(response.data.data);

                        if (window.location.href != url && window.location.href != baseURL+"/admin/project/edit/"+response.data.data.id || window.location.href!=baseURL+'/traffic') {
                            vueInstance.showExpiredProjectErrorAlert(url, 'Egy vagy több projekted határideje lejárt. Zárd le vagy módosítsd a határidejét.');
                        }
                    }

                })
                .catch(function(error){
                    console.log('error:');
                    console.log(error);
                });
        },
        showExpiredProjectErrorAlert: function(url, msg) {

            //POST THE CURRENT URL TO THE SESSION
            axios.post(baseURL+'/api/user/last_url',{
                "url":window.location.href
            })
            .then(function(data){
                console.log(data);
            });

            vex.dialog.open({
                message: msg,
                overlayClosesOnClick: false, // set false to click out
                callback: function (value) {
                    console.log(value);
                    location.href = url;
                },
                buttons: [
                    $.extend({}, vex.dialog.buttons.YES, { text: 'OK' }),
                ]
            });
        },
        showTimeSheetErrorAlert:function(){

            //POST THE CURRENT URL TO THE SESSION
            axios.post(baseURL+'/api/user/last_url',{
                "url":window.location.href
            })
            .then(function(data){
                vex.dialog.open({
                    message: 'Az előző munkanapodon nincs meg a kötelezően felvivendő időmennyiség. A rendezésig csak a traffic és a munkaidő feltöltő funkció elérhető.',
                    overlayClosesOnClick: false, // set false to click out
                    callback: function (value) {
                        console.log(value);
                        location.href = baseURL+'/traffic';
                    },
                    buttons: [
                        $.extend({}, vex.dialog.buttons.YES, { text: 'OK' }),
                    ]
                });
            });

        },
        bodyScroll: function() {
            this.scroll_indicator = $(window).scrollTop() > this.viewport_height / 2;
        },
        scrollToTop: function() {
            var body = $("html, body");
            body.stop().animate({
                scrollTop:0
            }, 100, 'swing');
        },
        selectFirstOption: function(target) {
            if ($("#select").find("option").length > 1) {

            }
            $(target).val($(target+" option:first").val());
        },
        urlFriendly: function(str) {

            var mit =['Á','á','Ö','ö','Ü','ü','Ó','ó','Ő','ő','Ú','ú','É','é','Ű','ű','í','Í','Î','Ï','Ñ','Ò','Ó','Ô','Õ','Ö','Ø','Ù','Ú','Û','Ü','Ý','Þ','ß','à','á','â','ã','ä','å','æ','ç','è','é','ê','ë','ì','í','î','ï','ð','ñ','ò','ó','ô','õ','ö','ø','ù','ú','û','ý','þ','ÿ','_', '@'],
                mire = ['a','a','o','o','u','u','o','o','o','o','u','u','e','e','u','u','i','i','I','I','N','O','O','O','O','O','O','U','U','U','U','Y','B','Ss','a','a','a','a','a','a','a','c','e','e','e','e','i','i','i','i','o','n','o','o','o','o','o','o','u','u','u','y','b','y','-', ''];
        
            return str.replaceArray(mit, mire).replace(/ +/g,'-').replace(/[-]{2,}/g, '-').replace(/[&\/\\#,+()$~%.'":*!?<>{}\[\]]/g, '').toLowerCase();
        },
        generateProjectUrl: function(project) {
            var url = baseURL + '/admin/project/'+project.id+'/'+this.urlFriendly(project.name);

            return url;
        },
        generateTicketUrl: function(project, ticket, editor = false) {
            if (!editor) {
                var url = baseURL + '/admin/project/'+project.id+'/ticket/'+ticket.id+'/'+this.urlFriendly(ticket.name);
            } else {
                var url = baseURL + '/admin/project/'+project.id+'/edit/ticket/'+ticket.id+'/';
            }

            return url;
        },
        generateProjectDownloadUrl: function(project) {
            var url = baseURL + '/admin/project/'+project.id+'/download/'+this.urlFriendly(project.client.name+"-"+project.name);

            return url;
        },
        humanizeValue:function(value) {
            switch (value) {
                case 0:
                    return 'Nem';
                case 1:
                    return 'Igen';
            }
        },
        humanizePhase:function(phase){
            switch (phase){
                case 'open':
                    return 'Létrehozva'
                    break;
                case 'active':
                    return 'Aktív'
                    break;
                case 'done':
                    return 'Belső teljesítés megtörtént.'
                    break;
                case 'client_notified':
                    return 'Ügyfél / gyártó értesítve. (Ellenőrzés alatt)'
                    break;
                case 'client_approved':
                    return 'Ügyfél / gyártó elfogadás megtörtént. (Pénzügyi zárás alatt)'
                    break;
                case 'completed':
                    return 'Fizetve / Teljesített'
                    break;
                default:
                    return phase;
            }
        }
    }
});

$( document ).ready( function(){
    checkCurrentUser();
});

/*
#/$$$$$$$$  /$$$$$$  /$$$$$$$$        /$$$$$$  /$$$$$$$  /$$$$$$ /$$   /$$
#| $$_____/ /$$__  $$| $$_____/       /$$__  $$| $$__  $$|_  $$_/| $$$ | $$
#| $$      | $$  \ $$| $$            | $$  \ $$| $$  \ $$  | $$  | $$$$| $$
#| $$$$$   | $$  | $$| $$$$$         | $$  | $$| $$  | $$  | $$  | $$ $$ $$
#| $$__/   | $$  | $$| $$__/         | $$  | $$| $$  | $$  | $$  | $$  $$$$
#| $$      | $$  | $$| $$            | $$  | $$| $$  | $$  | $$  | $$\  $$$
#| $$$$$$$$|  $$$$$$/| $$            |  $$$$$$/| $$$$$$$/ /$$$$$$| $$ \  $$
#|________/ \______/ |__/             \______/ |_______/ |______/|__/  \__/
*/
